// extracted by mini-css-extract-plugin
export default {"resetButton":"zusW7bE","root":"AgIyulX","content":"z5MLe3e","permissions":"pZhwoJP"};